var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-login-page"},[_c('CircularProgress',{attrs:{"message":_vm.$t('message.loggingIn')}})],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }